import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { VideoTable } from './components';
import { VideoHeader } from './components';
import { VideoFooter } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  }
}));

const VideoList = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {/* <VideoHeader/> */}
      <VideoTable/>
      <VideoFooter/>
      {/* <div style={{color:'grey', marginTop:'15px'}}>
        <p>*)pret de catalog orientativ. Poate varia marginal in functie de cursul valutar de la data comenzii.</p>
        <p>**)Produs similar ca tip, culoare, material si optionale. Nu se preiau cotele.</p>
      </div> */}
    </div>
    
  );
};

export default VideoList;

